import React, { FC } from 'react'
import HolidaysContainer from 'containers/Holidays'

const HolidaysPage: FC = () => <HolidaysContainer />

export default HolidaysPage
